<span class="countdown">
  @if (showDays) {
    <span class="countdown-item">
      <div class="countdown-label">Days</div>
      <div class="countdown-number">{{ countdown.days }}</div>
    </span>
  }
  <span class="countdown-item">
    <div class="countdown-label">Hours</div>
    <div class="countdown-number">{{ countdown.hours }}</div>
  </span>
  <span class="countdown-item">
    <div class="countdown-label">Minutes</div>
    <div class="countdown-number">{{ countdown.minutes }}</div>
  </span>
  <span class="countdown-item">
    <div class="countdown-label">Seconds</div>
    <div class="countdown-number">{{ countdown.seconds }}</div>
  </span>
</span>
